import { LeaveRequestApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

type Callback = (id: string, rejectReason?: string) => void;

const useHttpRejectLeaveRequest = () => {
    const { t } = useTranslation('leaveRequest');
    const leaveRequestApi: LeaveRequestApi = useContainer(LeaveRequestApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const rejectLeaveRequest = (id: string, callback: Callback, rejectReason?: string) => {
        const { exec, abort } = leaveRequestApi.reject({
            params: { id },
            body: { rejectReason },
            onSuccess: () => {
                toastHandler.push(`success`, t('notifications.rejectLeaveRequestTitle'), t('notifications.rejectLeaveRequestSucceededMessage'));
                callback(id, rejectReason);
            },
            onError: () => {
                toastHandler.push(`error`, t('notifications.rejectLeaveRequestTitle'), t('notifications.rejectLeaveRequestFailedMessage'));
            },
        });
        exec();
        return abort;
    };

    return { rejectLeaveRequest };
};

export default useHttpRejectLeaveRequest;
